// src/components/canine-teeth/ToolCanineTeeth.js

import React, { useEffect, useState } from 'react';
import ImageUpload from './ImageUpload';
import Topbar from '../Topbar';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import '../tools.css';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';

const ToolCanineTeeth = () => {
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
        }
      } else {
        setUser(null);
        navigate('/');
      }
  setIsAuthLoading(false); // Set isAuthLoading to false when auth state is determined
    });

    return () => unsubscribe();
  }, [navigate]);

  if (isAuthLoading) {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
                <p>Loading... Syncing profile info</p>
            </div>
        </div>
    );
}

  return (
    <div className="tool-container">
      {user && userInfo && <Topbar userInfo={userInfo} user={user} />}
      <h2>Age Estimation Using Carpal Bones Area</h2>
      <div className="bibliography-section" style={{ margin: '20px 0', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '5px', fontSize: '14px', lineHeight: '1.4' }}>
        <strong>Reference:</strong> Cameriere, R. & Ferrante, L. Age estimation in children by measurement of carpals and epiphyses of radius and ulna and open apices in teeth: a pilot study. Forensic Sci Int 174, 60–63 (2008).
      </div>
      {user ? <ImageUpload /> : <div>Please log in to use this tool.</div>}
    </div>
  );
};

export default ToolCanineTeeth;
